/**
 * @link https://mui.com/material-ui/react-button/
 */

import {Typography, Button, Divider} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeButton() {
  return (
    <>
      <Typography>Small (default)</Typography>
      <Button variant="contained" sx={{marginRight: "1rem"}}>Contained</Button>
      <Button variant="contained" disabled>Contained (disabled)</Button>
      <br/>
      <br/>

      <Typography>Medium</Typography>
      <Button variant="contained" size={"medium"} sx={{marginRight: "1rem"}}>Contained</Button>
      <Button variant="contained" size={"medium"} disabled>Contained (disabled)</Button>
      <br/>
      <br/>

      <Typography>Large</Typography>
      <Button variant="contained" size={"large"} sx={{marginRight: "1rem"}}>Contained</Button>
      <Button variant="contained" size={"large"} disabled>Contained (disabled)</Button>
      <br/>
      <br/>

      <Divider/>

      <Typography>Small (default)</Typography>
      <Button variant="outlined" sx={{marginRight: "1rem"}}>Outlined</Button>
      <Button variant="outlined" disabled>Outlined (disabled)</Button>
      <br/>
      <br/>

      <Typography>Medium</Typography>
      <Button variant="outlined" size={"medium"} sx={{marginRight: "1rem"}}>Outlined</Button>
      <Button variant="outlined" size={"medium"} disabled>Outlined (disabled)</Button>
      <br/>
      <br/>

      <Typography>Large</Typography>
      <Button variant="outlined" size={"large"} sx={{marginRight: "1rem"}}>Outlined</Button>
      <Button variant="outlined" size={"large"} disabled>Outlined (disabled)</Button>
      <br/>
      <br/>

      <Divider/>

      <Typography>Small (default)</Typography>
      <Button variant="text" sx={{marginRight: "1rem"}}>Text</Button>
      <Button variant="text" disabled>Text (disabled)</Button>
      <br/>
      <br/>

      <Typography>Medium</Typography>
      <Button variant="text" size={"medium"} sx={{marginRight: "1rem"}}>Text</Button>
      <Button variant="text" size={"medium"} disabled>Text (disabled)</Button>
      <br/>
      <br/>

      <Typography>Large</Typography>
      <Button variant="text" size={"large"} sx={{marginRight: "1rem"}}>Text</Button>
      <Button variant="text" size={"large"} disabled>Text (disabled)</Button>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Contained buttons */}
  <Button variant="contained">Contained</Button>
  <Button variant="contained" size="medium">Medium</Button>
  <Button variant="contained" size="large">Large</Button>
  <Button variant="contained" disabled>Disabled</Button>
  
  {/* Outlined buttons */}
  <Button variant="outlined">Outlined</Button>
  <Button variant="outlined" size="medium">Medium</Button>
  <Button variant="outlined" size="large">Large</Button>
  <Button variant="outlined" disabled>Disabled</Button>
  
  {/* Text buttons */}
  <Button variant="text">Text</Button>
  <Button variant="text" size="medium">Medium</Button>
  <Button variant="text" size="large">Large</Button>
  <Button variant="text" disabled>Disabled</Button>
</>`} 
        scope={{ React, Button }} 
      />
    </>
  )
}